import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

export interface TriageFiltersState {
  practitioner: string;
  status: string[];
  "triage-type": string[];
  location: string[];
}

const initialState: TriageFiltersState = {
  practitioner: "",
  status: [],
  "triage-type": [],
  location: [],
};

const slice = createSlice({
  name: "triageFilters",
  initialState,
  reducers: {
    setTriageFilters(
      state: TriageFiltersState,
      action: PayloadAction<Partial<TriageFiltersState>>,
    ): void {
      Object.assign(state, action.payload);
    },
    updateTriageFilter(
      state: TriageFiltersState,
      action: PayloadAction<{ key: string; value: any }>,
    ): void {
      const { key, value } = action.payload;
      (state as any)[key] = value;
    },
    resetTriageFilters(state: TriageFiltersState): void {
      Object.assign(state, initialState);
    },
  },
});

export const { setTriageFilters, updateTriageFilter, resetTriageFilters } =
  slice.actions;
export const { reducer } = slice;

export default slice;
